module.exports = __webpack_public_path__ + "img/p1.44066f65.png";